import CoachMarksView from './coach-marks/view';
import { instance as CompanyFactory } from '../../../factory/company';

module.exports = _.extend({
  initialize: function () {
    INKIVE.C.IS_MOBILE || this._load();
  },

  _load: async function () {
    return this._checkAddon()
      .then((response) => this._loadView(response));
  },

  _loadView: function (data) {
    if (!data.welcomeTour && !data.isDesygner) return;

    const view = document.createElement('div');
    view.id = 'coach-marks-panel';

    document.querySelector('body').appendChild(view);

    this.coachMarksView = new CoachMarksView({ el: view, data });
  },

  _checkAddon: async function () {
    const data = await CompanyFactory.initialize();

    return data.company.id === 1
      ? new Promise(resolve => resolve({ isDesygner: true }))
      : CompanyFactory.getCompanyItems('add_ons').then((addOns) => {
        return { welcomeTour: addOns.includes('coach_marks') };
      });
  }
}, Backbone.Events);
